import { render, staticRenderFns } from "./UPEIKspPreLab2V2.vue?vue&type=template&id=1d9c4b42&"
import script from "./UPEIKspPreLab2V2.vue?vue&type=script&lang=js&"
export * from "./UPEIKspPreLab2V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports